import React from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Annotation,
} from "react-simple-maps";
import { Link } from "react-router-dom";
import allStates from "../data/allstates.json";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const offsets = {
  VT: [50, -25],
  NH: [45, -10],
  MA: [40, 5],
  RI: [35, 20],
  CT: [30, 35],
  NJ: [15, 15],
  DE: [20, 30],
  MD: [25, 45],
  DC: [30, 60],
};

const MapChart = ({ setTooltipContent }) => {
  return (
    <div className="map-container">
      <ComposableMap
        projection="geoAlbersUsa"
        style={{
          width: '100%',
          height: 'auto',
          maxWidth: '1200px',
          maxHeight: '800px',
        }}
      >
        <Geographies geography={geoUrl}>
        {({ geographies }) => (
          <>
            {geographies.map((geo) => (
              <Link
                key={geo.rsmKey}
                to={`/state/${encodeURIComponent(geo.properties.name)}`}
              >
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: "#2a9d8f",
                      fillOpacity: 0.15,
                      stroke: "#264653",
                      strokeWidth: 0.5,
                      outline: "none",
                      transition: "all 0.3s ease"
                    },
                    hover: {
                      fill: "#2a9d8f",
                      fillOpacity: 0.5,
                      stroke: "#264653",
                      strokeWidth: 1.2,
                      outline: "none",
                      cursor: "pointer"
                    },
                    pressed: {
                      fill: "#217e73",
                      fillOpacity: 0.7,
                      stroke: "#264653",
                      strokeWidth: 1.2,
                      outline: "none"
                    },
                  }}
                />
              </Link>
            ))}
            {geographies.map((geo) => {
              const centroid = geoCentroid(geo);
              const cur = allStates.find((s) => s.val === geo.id);
              return (
                <g key={geo.rsmKey + "-name"}>
                  {cur &&
                    centroid[0] > -160 &&
                    centroid[0] < -67 &&
                    (Object.keys(offsets).indexOf(cur.id) === -1 ? (
                      <Marker coordinates={centroid}>
                        <text
                          className="text-[11px] sm:text-[13px] md:text-[14px]"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fill="var(--color-text)"
                          stroke="rgba(2, 6, 23, 0.45)"
                          strokeWidth="0.35"
                          strokeOpacity="0.9"
                          fontWeight="600"
                          style={{
                            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                            letterSpacing: '0.03em',
                            pointerEvents: 'none'
                          }}
                        >
                          {cur.id}
                        </text>
                      </Marker>
                    ) : (
                      <Annotation
                        subject={centroid}
                        dx={offsets[cur.id][0]}
                        dy={offsets[cur.id][1]}
                        connector={{
                          end: "dot",
                          type: "elbow",
                          stroke: "var(--color-border)",
                          strokeWidth: 1,
                          strokeOpacity: 0.8
                        }}
                      >
                        <rect
                          x={-1}
                          y={-7}
                          width={22}
                          height={14}
                          fill="var(--color-surface)"
                          fillOpacity="0.95"
                          rx={3}
                          stroke="var(--color-border)"
                          strokeWidth="1"
                        />
                        <text
                          x={10}
                          fontSize={12}
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fill="var(--color-text)"
                          fontWeight="700"
                          style={{
                            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                            letterSpacing: '0.04em',
                            pointerEvents: 'none'
                          }}
                        >
                          {cur.id}
                        </text>
                      </Annotation>
                    ))}
                </g>
              );
            })}
          </>
        )}
      </Geographies>
      </ComposableMap>
    </div>
  );
};

export default MapChart;
